module.exports = __webpack_public_path__ + "img/2-off.a6ffbc08.png";